import {
  ZIP_CODES,
  CLINIC_NAMES,
  PROGRAM_NAMES,
  USER_TYPES,
  INSURANCE_OPTIONS,
} from "./constants.js";

const MENTAL_HEALTH = "MH";

const NOT_PROGRAMS = new Set([
  PROGRAM_NAMES.PEER,
  PROGRAM_NAMES.TELEHEALTH,
  PROGRAM_NAMES.INJECTABLE,
  PROGRAM_NAMES.MINOR,
]);
const ROCKLAND_WESTCHESTER = new Set([
  ...ZIP_CODES.ROCKLAND,
  ...ZIP_CODES.WESTCHESTER,
]);
const ROCKLAND_DUTCHESS_WESTCHESTER = new Set([
  ...ROCKLAND_WESTCHESTER,
  ...ZIP_CODES.DUTCHESS,
]);
const DUTCHESS_ORANGE_ULSTER = new Set([
  ...ZIP_CODES.DUTCHESS,
  ...ZIP_CODES.ORANGE,
  ...ZIP_CODES.ULSTER,
]);
const DUTCHESS_ORANGE_ULSTER_WESTCHESTER = new Set([
  ...DUTCHESS_ORANGE_ULSTER,
  ...ZIP_CODES.WESTCHESTER,
]);
const DUTCHESS_ORANGE_SULLIVAN_ULSTER_WESTCHESTER = new Set([
  ...DUTCHESS_ORANGE_ULSTER_WESTCHESTER,
  ...ZIP_CODES.SULLIVAN,
]);
const DUTCHESS_ORANGE_PUTNAM_ROCKLAND_ULSTER = new Set([
  ...DUTCHESS_ORANGE_ULSTER,
  ...ZIP_CODES.PUTNAM,
  ...ZIP_CODES.ROCKLAND,
]);
const DUTCHESS_ORANGE_PUTNAM_ROCKLAND_SULLIVAN_ULSTER = new Set([
  ...DUTCHESS_ORANGE_PUTNAM_ROCKLAND_ULSTER,
  ...ZIP_CODES.SULLIVAN,
]);
const DUTCHESS_ORANGE_PUTNAM_SULLIVAN_ULSTER_WESTCHESTER = new Set([
  ...DUTCHESS_ORANGE_SULLIVAN_ULSTER_WESTCHESTER,
  ...ZIP_CODES.PUTNAM,
]);
const DUTCHESS_ORANGE_PUTNAM_ROCKLAND_SULLIVAN_WESTCHESTER = new Set([
  ...ROCKLAND_WESTCHESTER,
  ...ZIP_CODES.DUTCHESS,
  ...ZIP_CODES.ORANGE,
  ...ZIP_CODES.PUTNAM,
  ...ZIP_CODES.SULLIVAN,
]);
const MEDICAID_COMBO = new Set([
  INSURANCE_OPTIONS.MEDICAID,
  INSURANCE_OPTIONS.MANAGED_MEDICAID,
]);
const MEDICAID_COMBO_PLUS_MEDICARE = new Set([
  ...MEDICAID_COMBO,
  INSURANCE_OPTIONS.MEDICARE,
]);
const GMHNY_INSURANCES = new Set([
  INSURANCE_OPTIONS.MVP,
  INSURANCE_OPTIONS.FIDELIS,
  INSURANCE_OPTIONS.UNITED,
  INSURANCE_OPTIONS.MOLINA,
  INSURANCE_OPTIONS.HEALTH_FIRST,
  INSURANCE_OPTIONS.PARTNERS,
  INSURANCE_OPTIONS.AETNA,
  INSURANCE_OPTIONS.MEDICAID,
  INSURANCE_OPTIONS.MANAGED_MEDICAID,
  INSURANCE_OPTIONS.MEDICARE,
]);
const LEXINGTON_INSURANCES = new Set([
  INSURANCE_OPTIONS.FIDELIS,
  INSURANCE_OPTIONS.HEALTH_FIRST,
  INSURANCE_OPTIONS.MEDICAID,
  INSURANCE_OPTIONS.MOLINA,
  INSURANCE_OPTIONS.MVP,
  INSURANCE_OPTIONS.UNITED,
]);
const LEXINGTON_PROGRAMS = [
  PROGRAM_NAMES.MAT,
  PROGRAM_NAMES.OTP,
  PROGRAM_NAMES.DAY_REHAB,
];
const CLINICS = new Set([
  CLINIC_NAMES.ACCESS,
  CLINIC_NAMES.GMHNY,
  CLINIC_NAMES.LEXINGTON,
]);

const alertFilter = (
  {
    alertZIP,
    alertType,
    existingClinic,
    indicators,
    insuranceProvider,
    unclaimedClinics = [],
  },
  clinic,
) => {
  if (clinic === existingClinic) {
    return true;
  } else if (existingClinic !== null) {
    return false;
  }
  if (unclaimedClinics.includes(clinic)) return false;
  if (insuranceProvider.includes("Other-")) return true;

  const programs = new Set();
  for (const [isProgram, present] of Object.entries(indicators)) {
    if (NOT_PROGRAMS.has(isProgram)) continue;
    if (present) {
      programs.add(isProgram);
    }
  }
  const noPrograms = programs.size === 0;

  switch (clinic) {
    case CLINIC_NAMES.ACCESS: {
      if (noPrograms) {
        if (DUTCHESS_ORANGE_SULLIVAN_ULSTER_WESTCHESTER.has(alertZIP)) {
          return true;
        }
      }
      if (programs.has(PROGRAM_NAMES.CTI)) {
        if (DUTCHESS_ORANGE_PUTNAM_ROCKLAND_SULLIVAN_ULSTER.has(alertZIP)) {
          return true;
        }
      }
      if (programs.has(PROGRAM_NAMES.PROS)) {
        if (DUTCHESS_ORANGE_ULSTER_WESTCHESTER.has(alertZIP)) {
          if (MEDICAID_COMBO.has(insuranceProvider)) {
            return true;
          }
        }
      }
      if (programs.has(PROGRAM_NAMES.ON_TRACK)) {
        if (DUTCHESS_ORANGE_ULSTER_WESTCHESTER.has(alertZIP)) {
          if (MEDICAID_COMBO.has(insuranceProvider)) {
            return true;
          }
        }
      }
      if (programs.has(PROGRAM_NAMES.MAT)) {
        if (DUTCHESS_ORANGE_ULSTER_WESTCHESTER.has(alertZIP)) {
          return true;
        }
      }
      if (programs.has(PROGRAM_NAMES.OTP)) {
        if (DUTCHESS_ORANGE_PUTNAM_ROCKLAND_SULLIVAN_ULSTER.has(alertZIP)) {
          if (MEDICAID_COMBO_PLUS_MEDICARE.has(insuranceProvider)) {
            return true;
          }
        }
      }
      break;
    }
    case CLINIC_NAMES.GMHNY: {
      if (noPrograms) {
        if (ROCKLAND_WESTCHESTER.has(alertZIP)) {
          return true;
        }
      }
      if (programs.has(PROGRAM_NAMES.IOP)) {
        if (ROCKLAND_WESTCHESTER.has(alertZIP)) {
          return true;
        }
      }
      if (programs.has(PROGRAM_NAMES.CTI)) {
        if (ZIP_CODES.WESTCHESTER.includes(alertZIP)) {
          return true;
        }
      }
      if (programs.has(PROGRAM_NAMES.PROS)) {
        if (ZIP_CODES.ROCKLAND.includes(alertZIP)) {
          return true;
        }
      }
      if (programs.has(PROGRAM_NAMES.ON_TRACK)) {
        if (ZIP_CODES.WESTCHESTER.includes(alertZIP)) {
          return true;
        }
      }
      if (programs.has(PROGRAM_NAMES.MAT)) {
        if (ROCKLAND_WESTCHESTER.has(alertZIP)) {
          return true;
        }
      }
      break;
    }
    case CLINIC_NAMES.LEXINGTON: {
      if (alertType === MENTAL_HEALTH) {
        return false;
      }
      if (noPrograms) {
        return true;
      }
      if (programs.has(PROGRAM_NAMES.MAT)) {
        return true;
      }
      if (programs.has(PROGRAM_NAMES.OTP)) {
        return true;
      }
      if (programs.has(PROGRAM_NAMES.DAY_REHAB)) {
        if (ROCKLAND_DUTCHESS_WESTCHESTER.has(alertZIP)) {
          return true;
        }
      }
      break;
    }
  }
  return false;
};

export const isAlertOnAnyDashboard = (alertData) => {
  for (const clinic of CLINICS) {
    const isOnDashboard = alertFilter(alertData, clinic);
    if (isOnDashboard) {
      return true;
    }
  }
  return false;
};

export default alertFilter;
